module.exports = __webpack_public_path__ + "static/img/wxgzh.170c64e1.jpg";